export default {
  // Obtiene los calendarios
  async getCalendar(params) {
    const response = await Vue.http.get('schedule/calendar', {params})
    return response.data.data
  },

  async getJourneys(params) {
    const response = await Vue.http.get('schedule/journeys', {params})
    return response.data.data
  }
}
